import { useEffect, useState } from 'react';
import useDebouncedValue from './useDebouncedValue';
/**
 * Debounced the value, but always begins with a value of undefined
 * @param value the value to delay & debounce
 * @param wait Time in milliseconds to debounce by
 * @param debounceSettings The debounce settings, used by the lodash debounce function
 * @returns The delayed and debounced value
 */
export default function useDelayedValue(value, wait, debounceSettings) {
  const [lastValue, setLastValue] = useState(undefined);
  const debouncedValue = useDebouncedValue(lastValue, wait, debounceSettings);
  useEffect(() => {
    setLastValue(value);
  }, [value]);
  return debouncedValue;
}